module.exports = __webpack_public_path__ + "static/media/product-basket.6aa09c49.svg";